<section class="flex flex-column gap-3" data-testid="graficos-shell">
  <h1 class="m-0 text-xl font-medium">Gráficos</h1>
  @if (iglesiaQuery()) {
    <p class="m-0 text-sm text-color-secondary">{{ iglesiaQuery() }}</p>
  }

  @if (loading()) {
    <div data-testid="graficos-loading">
      <app-skeleton-block variant="cards" />
    </div>
  } @else if (loadError()) {
    <p class="m-0 text-sm text-red-500" data-testid="graficos-error">{{ loadError() }}</p>
  } @else if (suspendido()) {
    <p-card data-testid="graficos-suspendido">
      <h2 class="m-0 mb-2 text-lg font-medium">Servicio no disponible</h2>
      <p class="m-0 text-sm text-color-secondary">
        @if (iglesia()!.suspender) {
          La iglesia está suspendida.
        } @else {
          El servicio de la iglesia está desactivado.
        }
      </p>
      @if (iglesia()!.mensajeIglesia) {
        <p class="m-0 mt-2 text-sm">{{ iglesia()!.mensajeIglesia }}</p>
      }
    </p-card>
  } @else {
    <div class="flex flex-wrap gap-2" data-testid="graficos-vistas">
      <p-button
        label="Resumen"
        [outlined]="vista() !== 'resumen'"
        (onClick)="verResumen()"
        data-testid="graficos-vista-resumen"
      />
      <p-button
        label="Organigrama"
        [outlined]="vista() !== 'organigrama'"
        (onClick)="verOrganigrama()"
        data-testid="graficos-vista-organigrama"
      />
    </div>

    @if (vista() === 'organigrama') {
      <app-organigrama [nombrePastor]="iglesia()?.nombrePastor ?? ''" />
    } @else {
    <div class="grid" data-testid="graficos-resumen">
      <div class="col-6 lg:col-3">
        <p-card styleClass="h-full">
          <p class="m-0 text-sm text-color-secondary">Cant. Admin</p>
          <p class="m-0 mt-1 text-xl font-medium">{{ cantAdminVista() ?? '—' }}</p>
        </p-card>
      </div>
      <div class="col-6 lg:col-3">
        <p-card styleClass="h-full">
          <p class="m-0 text-sm text-color-secondary">Cant. Líder</p>
          <p class="m-0 mt-1 text-xl font-medium">{{ cantLideresVista() ?? '—' }}</p>
        </p-card>
      </div>
      <div class="col-6 lg:col-3">
        <p-card styleClass="h-full">
          <p class="m-0 text-sm text-color-secondary">Pers. en célula</p>
          <p class="m-0 mt-1 text-xl font-medium">{{ enCelulaVista() ?? '—' }}</p>
        </p-card>
      </div>
      <div class="col-6 lg:col-3">
        <p-card styleClass="h-full">
          <p class="m-0 text-sm text-color-secondary">Pers. sin célula</p>
          <p class="m-0 mt-1 text-xl font-medium">{{ sinCelulaVista() ?? '—' }}</p>
        </p-card>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 lg:col-6">
        <p-card styleClass="h-full grafico-lleno" data-testid="grafico-domingo">
          <h2 class="m-0 mb-1 text-lg font-medium">Asistencia Domingo</h2>
          <div class="flex align-items-center gap-2 mb-2">
            <p-button icon="pi pi-chevron-left" [text]="true" (onClick)="domingoAnterior()" ariaLabel="Semana anterior" />
            <span class="text-sm">{{ domingoVisible() }}</span>
            <p-button
              icon="pi pi-chevron-right"
              [text]="true"
              [disabled]="domingoAtras() <= 0"
              (onClick)="domingoSiguiente()"
              ariaLabel="Semana siguiente"
            />
          </div>
          @if (domingoAtraso(); as atraso) {
            <p class="m-0 mb-2 text-sm text-color-secondary">{{ atraso }}</p>
          }
          @if (domingoSerie(); as serie) {
            <app-grafico-serie type="line" [data]="serie" />
          } @else if (domingoError()) {
            <p class="m-0 text-sm text-red-500">{{ domingoError() }}</p>
          } @else {
            <app-skeleton-block variant="chart" />
          }
        </p-card>
      </div>
      <div class="col-12 lg:col-6">
        <p-card styleClass="h-full grafico-lleno" data-testid="grafico-celula">
          <h2 class="m-0 mb-1 text-lg font-medium">Asistencia Célula</h2>
          <div class="flex align-items-center gap-2 mb-2">
            <p-button icon="pi pi-chevron-left" [text]="true" (onClick)="celulaAnterior()" ariaLabel="Semana anterior" />
            <span class="text-sm">{{ celulaVisible() }}</span>
            <p-button
              icon="pi pi-chevron-right"
              [text]="true"
              [disabled]="celulaAtras() <= 0"
              (onClick)="celulaSiguiente()"
              ariaLabel="Semana siguiente"
            />
          </div>
          @if (celulaAtraso(); as atraso) {
            <p class="m-0 mb-2 text-sm text-color-secondary">{{ atraso }}</p>
          }
          @if (celulaSerie(); as serie) {
            <app-grafico-serie type="line" [data]="serie" />
          } @else if (celulaError()) {
            <p class="m-0 text-sm text-red-500">{{ celulaError() }}</p>
          } @else {
            <app-skeleton-block variant="chart" />
          }
        </p-card>
      </div>
      <div class="col-12 lg:col-6">
        <p-card styleClass="h-full" data-testid="grafico-sexo">
          <h2 class="m-0 mb-1 text-lg font-medium">Porcentaje Sexo</h2>
          @if (sexoPie(); as pie) {
            <app-grafico-torta [data]="pie" />
          } @else if (piesError()) {
            <p class="m-0 text-sm text-red-500">{{ piesError() }}</p>
          } @else {
            <app-skeleton-block variant="chart" />
          }
        </p-card>
      </div>
      <div class="col-12 lg:col-6">
        <p-card styleClass="h-full grafico-lleno" data-testid="grafico-edades">
          <h2 class="m-0 mb-1 text-lg font-medium">Distribución por Edades</h2>
          @if (edadesBar(); as barra) {
            <app-grafico-barra [data]="barra" [mostrarPorcentaje]="true" [llenar]="true" />
          } @else if (distribucionError()) {
            <p class="m-0 text-sm text-red-500">{{ distribucionError() }}</p>
          } @else {
            <app-skeleton-block variant="chart" />
          }
        </p-card>
      </div>
      @if (showNiveles()) {
        <div class="col-12 lg:col-6">
          <p-card styleClass="h-full" data-testid="grafico-niveles">
            <h2 class="m-0 mb-1 text-lg font-medium">Distribución por Niveles</h2>
            @if (nivelesBar(); as barra) {
              <app-grafico-barra [data]="barra" />
            } @else if (distribucionError()) {
              <p class="m-0 text-sm text-red-500">{{ distribucionError() }}</p>
            } @else {
              <app-skeleton-block variant="chart" />
            }
          </p-card>
        </div>
      }
      @if (showReunion()) {
        <div class="col-12 lg:col-6">
          <p-card styleClass="h-full" data-testid="grafico-reunion">
            <h2 class="m-0 mb-1 text-lg font-medium">Reuniones Selectivas</h2>
            @if (reunionPie(); as pie) {
              <app-grafico-torta [data]="pie" />
            } @else if (distribucionError()) {
              <p class="m-0 text-sm text-red-500">{{ distribucionError() }}</p>
            } @else {
              <app-skeleton-block variant="chart" />
            }
          </p-card>
        </div>
      }
      <div class="col-12 lg:col-6">
        <p-card styleClass="h-full" data-testid="grafico-bautismo">
          <h2 class="m-0 mb-1 text-lg font-medium">Estado de Bautismo</h2>
          @if (bautismoPie(); as pie) {
            <app-grafico-torta [data]="pie" />
          } @else if (piesError()) {
            <p class="m-0 text-sm text-red-500">{{ piesError() }}</p>
          } @else {
            <app-skeleton-block variant="chart" />
          }
        </p-card>
      </div>
      @if (showMapa()) {
        <div class="col-12">
          <p-card data-testid="grafico-mapa">
            <div class="flex align-items-center justify-content-between gap-2 mb-2">
              <h2 class="m-0 text-lg font-medium">Mapa de Células</h2>
              @if (mapaCelulas()) {
                <p-button label="Ocultar" icon="pi pi-eye-slash" [outlined]="true" size="small" (onClick)="cerrarMapa()" />
              } @else {
                <p-button
                  label="Ver mapa"
                  icon="pi pi-map"
                  size="small"
                  [loading]="mapaLoading()"
                  (onClick)="verMapa()"
                />
              }
            </div>
            @if (mapaCelulas(); as celulas) {
              <app-mapa-celulas [celulas]="celulas" />
            } @else if (mapaLoading()) {
              <app-skeleton-block variant="chart" />
            } @else if (mapaError()) {
              <p class="m-0 text-sm text-red-500">{{ mapaError() }}</p>
            } @else {
              <p class="m-0 text-sm text-color-secondary">
                Ubicación de las células registradas. Solo visible para administradores.
              </p>
            }
          </p-card>
        </div>
      }
    </div>
    }
  }
</section>
